import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Breadcumb from './Breadcumb';
import PackageCard from './PackageCard';
import LetsTalk from './LetsTalk';
import { fetchMetadata } from '../../utils/api';

function Main() {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const data = await fetchMetadata();
        const domesticMetadata = data.find((item) => item.pageName === 'domestic');
        if (!domesticMetadata) {
          setError('Domestic page metadata not found');
          setLoading(false);
          return;
        }
        setSeoData(domesticMetadata);
        setLoading(false);
      } catch (err) {
        setError('Failed to load SEO metadata');
        setLoading(false);
      }
    };
    loadMetadata();
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'Domestic | Bluelagoon Travels'}</title>
        <meta
          name='description'
          content={seoData?.description || 'Explore India with Bluelagoon Travels.'}
        />
        <meta
          name='keywords'
          content={seoData?.keywords || 'domestic tours, India travel'}
        />
        <meta
          name='pageName'
          content={seoData?.pageName || 'domestic'}
        />
      </Helmet>
      <Breadcumb />
      <PackageCard />
      <LetsTalk />
    </>
  );
}

export default Main;
